import React from 'react';
import { Box, Typography } from '@mui/material';
import cn from 'classnames';


import { useStyles } from './styles';

type SettingItemProps = {
    text: string;
    icon: string;
    onClick: () => void;
    customBoxStyle?: string | undefined;
    customBoxIconStyle?: string | undefined;
};

// const useStyles = makeStyles({
//     settingItemBox: {
//         display: 'grid',
//         gridTemplateColumns: 'auto auto',
//         gridColumnGap: 12,
//         justifyContent: 'flex-start',
//         cursor: 'pointer',
//     },
//     settingItemText: {
//         fontSize: 16,
//         fontWeight: 500,
//         color: appColors.txt800,
//     },
// });

const SettingItem = ({
    text,
    icon,
    onClick,
    customBoxStyle,
    customBoxIconStyle,
}: SettingItemProps) => {
    const styles = useStyles();
    return (
        <Box
            className={cn(styles.settingItemBox, customBoxStyle)}
            onClick={onClick}
        >
            <img
                src={icon}
                className={cn(styles.settingItemIcon, customBoxIconStyle)}
            />
            <Typography className={styles.settingItemText}>{text}</Typography>
        </Box>
    );
};

export default SettingItem;
